const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="social-links">
          <a href="https://twitter.com/bhushanborole26" className="twitter">
            <i className="bx bxl-twitter"></i>
          </a>
          <a
            href="https://www.instagram.com/barham.farraj"
            className="instagram"
          >
            <i className="bx bxl-instagram"></i>
          </a>
          <a href="https://github.com/Farraj007" className="google-plus">
            <i className="bx bxl-github"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/barham-farraj-258683147/"
            className="linkedin"
          >
            <i className="bx bxl-linkedin"></i>
          </a>
          <a href="mailto:Barhamfarraj@icloud.com">
            <i className="bx bx-envelope"></i>
          </a>
        </div>
        <div className="credits">
          BarhamFarraj &trade; using
          React
        </div>
      </div>
    </footer>
  );
};

export default Footer;
